import React from 'react';

export const LuWargos = ({size = 18,className}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 50 50" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.7963 28.5518L7.24948 18.0512L4.76788 0.015564L24.9901 8.46068L17.7963 28.5518Z" fill="currentColor"/>
      <path d="M14.7945 37.9983L0 26.2258L6.58588 18.6601L14.7945 37.9983Z" fill="currentColor"/>
      <path d="M43.4141 18.6601L35.2056 37.9983L50 26.2258" fill="currentColor" />
      <path d="M20.0872 46.9596H29.9253L24.9897 29.4266L20.0872 46.9596Z" fill="currentColor"/>
      <path d="M22.0977 50L20.0932 47.3392L19.4011 48.4928L22.0977 50Z" fill="currentColor"/>
      <path d="M30.6307 48.4928L27.9348 50L29.9386 47.3392" fill="currentColor"/>
      <path d="M32.22 28.5363L42.7668 18.0357L45.2484 3.05176e-05L25.0255 8.44515L32.22 28.5363Z" fill="currentColor"/>
    </svg>
  );
};